import React from 'react';

import { EmptyPage } from 'apps/auth/components/common/Layout/EmptyPage/EmptyPage';

export const NotFoundResult = (props) => {
    return <EmptyPage iconName="ghost" emptyText={props.notFoundMessage} />;
};
